import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit(event: Event): void {
    const target = event.target as HTMLInputElement;

    if (target.form) {
      target.form.requestSubmit();
    }
  }

  showButton(): void {
    $('#applyFilters').show(300);
  }
}